import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HideHeaderService } from "../../services/hide-header.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth/auth.service";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
	@Input() isOpenMobileMenu = false;
	@Output() isOpenMobileMenuChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Input() headerTitle: string | undefined;

	isActive = false;

	currentLang!: string;
	codeLang = "RU";

	constructor(
		private translateService: TranslateService,
		private authService: AuthService,
		private router: Router
	) {}

	ngOnInit() {
		this.initLang();
	}

	logout() {
		this.authService.logout();
		this.router.navigate(["/login"]);
	}

	openMobileMenu() {
		this.isOpenMobileMenu = true;
		this.isOpenMobileMenuChange.emit(this.isOpenMobileMenu);
	}

	changeLang(lang: string) {
		this.translateService.use(lang);
		localStorage.setItem("locale", lang);
		this.initLang();
		location.reload();
	}

	initLang() {
		if (localStorage.getItem("locale") === "ru") {
			this.codeLang = "RU";
			this.currentLang = "LANG.RU";
		}
		if (localStorage.getItem("locale") === "kk") {
			this.codeLang = "KK";
			this.currentLang = "LANG.KK";
		}
	}
}
